import { createSlice } from '@reduxjs/toolkit';
import { AuthState } from './types';
import { accountApiEndpoints } from '@netiva/classifieds-api';

export * from './types';

const initialState: AuthState = {
  isLoading: true,
  isLocked: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(accountApiEndpoints.getAccounts.matchFulfilled, (state) => {
      state.isLoading = false;
      state.isLocked = false;
    });
    builder.addMatcher(accountApiEndpoints.getAccounts.matchRejected, (state, action) => {
      state.isLoading = false;
      state.isLocked = action.payload?.status === 423;
    });
  },
});

export const authActions = authSlice.actions;
